
import { Injectable } from '@angular/core';

import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { UnsplashResponse, Result } from '../unsplash/unsplash.response';
import { environment } from '../../environments/environment';
import { Image } from './image-results';

@Injectable()
export class UnsplashImageService {

  constructor(private http: Http) {


  }

  SendDownloadRequest(url: string) {
    return this.http.get(url, this.requestOptions())
      .subscribe(x => {

      });

  }

  GetUnsplashImages(query: string, pageNo: number, collectionId: string = '', onlyVideos: boolean = false): Observable<Image[]> {
    let cacheKey = 'images-query-' + query + 'pageNo-' + pageNo;
    if (collectionId) {
      cacheKey = cacheKey + 'collection-' + collectionId;
    }

    if (query) {
      query = query.trim();
    }
    return this.http.get(`${environment.firebase.clouldFunctionHost}/getHitchdImages?query=${query}&xp=search-and:experiment&per_page=30&page=${pageNo}&collectionId=${collectionId}&onlyVideos=${onlyVideos}`)
      .map((res: any) => {

        
          const response: Image[] = res.json();
          return response;
    
        
      })
  }



  GetImages(query: string, pageNo: number, collectionId: string = ''): Observable<UnsplashResponse> {


    let cacheKey = 'images-query-' + query + 'pageNo-' + pageNo;
    if (collectionId) {
      cacheKey = cacheKey + 'collection-' + collectionId;
    }


    if (query) {
      query = query.trim();
    }
    // ttps://unsplash.com/napi/search/photos?query=cats&xp=search-and:experiment&per_page=20&page=
    let unsplashUrl = 'https://api.unsplash.com/search/photos?query='
      + query + '&xp=search-and:experiment&per_page=30&page='
      + pageNo;

    if (collectionId) {
      unsplashUrl = 'https://api.unsplash.com/collections/' + collectionId + '/photos?per_page=60&page=1';
    }


    return this.http.get(unsplashUrl, this.requestOptions())
      .map((res: any) => {

        if (collectionId) {
          const response = res.json();
          const result: Result[] = response;
          const test = 'isuru';
          const searchResult = new UnsplashResponse();
          searchResult.results = new Array<Result>();



          result.forEach(unsplashResult => {
            const unsplash = new Result();
            unsplash.color = unsplashResult.color;
            unsplash.urls = unsplashResult.urls;
            unsplash.links = unsplashResult.links;
            unsplash.user = unsplashResult.user;
            searchResult.results.push(unsplash);
          });
          searchResult.total = searchResult.results.length;
          searchResult.total_pages = 1;

          return searchResult;
        }

        return res.json();
      })
      .catch(this.handleError);
  }


  private requestOptions(): RequestOptions {
    const headers = new Headers({ 'authorization': 'Client-ID 4ad5d5abc9619fefeead1780bf1b9d55d2b2c8c275f918b29963d89ccd0dc398' }); // ... Set content type to JSON
    const options = new RequestOptions({ headers: headers });
    return options;
  }

  private handleError(error: Response | any) {
    if (error.status === 400) {

      const errorText = error._body;
      return Observable.throw(errorText);
    }
    if (error.status === 404) {

      location.href = '/404';
      return Observable.throw('not found');

    }
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `$ {error.status} - $ {error.statusText || ''}$ {err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/app/unsplash/unsplash.service.ts